// ── SERVICES — centred phrase with objects orbiting around it ─────
import React, { useState, useCallback, useEffect, useRef } from "react";
import SplashCursor from "../components/SplashCursor";
import OrbitImages from "../components/OrbitImages";
import { useViewport } from "../context/ViewportContext";
import { useNavigate } from 'react-router-dom'
import useBodyScrollLock from "../hooks/useBodyScrollLock";


const PU = process.env.PUBLIC_URL;

const ORBIT_IMAGES = [
  {
    a: `${PU}/assets/orbit/orbit1A.png`,
    b: `${PU}/assets/orbit/orbit1B.png`,
    text: "curated playlist",
  },
  {
    a: `${PU}/assets/orbit/orbit2A.png`,
    b: `${PU}/assets/orbit/orbit2B.png`,
    text: "Gluten free nerds",
  },
  {
    a: `${PU}/assets/orbit/orbit3A.png`,
    b: `${PU}/assets/orbit/orbit3B.png`,
    text: "Feeling lucky?",
  },
  {
    a: `${PU}/assets/orbit/orbit4A.png`,
    b: `${PU}/assets/orbit/orbit4B.png`,
    text: "Infinite TBR",
  },
  {
    a: `${PU}/assets/orbit/orbit5A.png`,
    b: `${PU}/assets/orbit/orbit5B.png`,
    text: "Contact us",
  },
  {
    a: `${PU}/assets/orbit/orbit6A.png`,
    b: `${PU}/assets/orbit/orbit6B.png`,
    text: "Let's play",
  },
];

const BallResponses = [
  `${PU}/assets/orbit/8ball/bola-ocho_01.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_02.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_03.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_04.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_05.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_06.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_07.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_08.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_09.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_10.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_11.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_12.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_13.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_14.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_15.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_16.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_17.png`,
  `${PU}/assets/orbit/8ball/bola-ocho_18.png`,
];

function Services() {
  const navigate = useNavigate()
  const [ballStage, setBallStage] = useState(null);
  const [selectedBallImg, setSelectedBallImg] = useState(null);
    const [visible, setVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { isMobile } = useViewport();
  const { isTrueMobile } = useViewport();
  useBodyScrollLock(Boolean(ballStage));
  const sectionRef = useRef(null);
  const orbitSectionRef = useRef(null);

  const handleOrbit3Hover = useCallback(() => {
    const random =
      BallResponses[Math.floor(Math.random() * BallResponses.length)];


    setSelectedBallImg(random);
    setBallStage("prompt");
  }, []);

  const handleDareClick = useCallback(() => {
    setBallStage("result");
  }, []);

  const closeBallModal = useCallback(() => {
    setBallStage(null);
    setSelectedBallImg(null);
  }, []);

  const handleOrbit3Leave = useCallback(() => {
    // keep visible until click
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const itemSizeHelper = () => {
    let size = 180;
    if (windowWidth < 800) {
      size = 330;
    }else{
      if(windowWidth < 1200){
        size = 250;
      }
    }
    

    return size;
  }

  const radiusXHelper = () => {
    let size = 430;
    if (windowWidth < 700) {
      size = 500;
    }else{
      if(windowWidth < 1200){
        size = 500;
      }
    }

    return size;
  }

  const radiusYHelper = () => {
    let size = 250;
    if (windowWidth < 700) {
      size = 800;
    }else{
      if(windowWidth < 1200){
        size = 300;
      }
    }



    return size;
  }

    const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop, behavior: "smooth" });
  };

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => setVisible(entry.isIntersecting),
        { threshold: 0.1 },
      );
      if (sectionRef.current) observer.observe(sectionRef.current);
      return () => observer.disconnect();
    }, []);


  return (
    <section
      className="section services"
      id="services"
      data-screen-label="Services"
      ref={sectionRef}
    >
      {visible && !isTrueMobile && <SplashCursor />}

      {/* 8-ball overlay */}
      {ballStage && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", position: "fixed", top: 0, left: 0, width: "100vw", height: "100dvh", backgroundColor: "rgba(0, 0, 0, 0.8)", zIndex: 1000 }}>
          <button
            className="modal__close modal__close--outside ball-close"

            onClick={closeBallModal}
            aria-label="Cerrar"
          >
            <p style={{ color: "#ffffff" }}>Cerrar</p>
          </button>
          <div
          className="ball-container"
            style={{
              background: `url(${PU}/assets/bg_8ball.png) no-repeat center center / cover`,

              animation: "ballFadeIn 0.4s ease forwards",
            }}
          >
            {ballStage === "prompt" ? (
              <>
                <p className="ball-title">ONE QUESTION ONLY</p>
                <div className="breathing-ani" style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", flex: 1 }}>
                  <img
                    src={`${PU}/assets/bola8_blank.png`}
                    alt="8ball"
                    draggable={false}
                    className="ball-img2"
                    style={{ paddingTop: 0 }}
                  />
                  
                </div>
                <button
                    className="btn-signal dare-btn"
                    onClick={handleDareClick}
                    aria-label="DARE"
                    
                  >
                    DARE!
                  </button>
              </>
            ) : (
              <>
                <p className="ball-title">La bola Cool Nerdy People dice:</p>
                <div className="breathing-ani" style={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", flex: 1 }}>
                  <img
                    src={selectedBallImg}
                    alt="8ball response"
                    draggable={false}
                    className="ball-img"
                  />
                </div>
                                <button
                    className="btn-signal dare-btn"
                    onClick={handleDareClick}
                    style={{ scale: "0" }}
                    aria-label="DARE"
                    
                  >
                    DARE!
                  </button>
              </>
            )}
          </div>
        </div>
      )}

      <style>{`
        @keyframes ballFadeIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes ballScaleIn {
          from { transform: scale(0.6); opacity: 0; }
          to   { transform: scale(1);   opacity: 1; }
        }
      `}</style>

      {!ballStage && (
        <div className="services__stage" ref={orbitSectionRef}>
        <OrbitImages
          images={ORBIT_IMAGES}
          shape="ellipse"
          radiusX={radiusXHelper()}
          radiusY={radiusYHelper()}
          rotation={0}
          duration={50}
          itemSize={itemSizeHelper()}
          responsive={true}
          showPath={false}
          itemCallbacks={{
            2: { onHover: handleOrbit3Hover, onLeave: handleOrbit3Leave },
            3: { onHover: () => window.open('https://www.goodreads.com/coolnerdypeople', '_blank') },
            5: { onHover: () => navigate('/game') },
            4: { onHover: () => scrollTo("contacto") }
          }}
          centerContent={

            !ballStage ? (<div className="services__center">
              <h2 className="horizon services__head reveal">
                Get
                <br />
                Today's
                <br />
                Creative
                <br />
                <span style={{ color: "#00ABFF" }}>SPARK</span>
              </h2>
              {isMobile ? (
                <p className="services__sub reveal">
                  Feed your brain:
                  <br />
                  Tap an object
                </p>
              ) : <p className="services__sub reveal" style={{ fontSize: "12px", marginTop: "0px" }}>
                  Feed your brain: Tap an object

                  
                </p>}
            </div>) : null
          }
        />
      </div>
      )}
    </section>
  );
}

export default Services;
